import { createContext } from '@lit/context';
import { ProductAvailabilityStore } from '../state/product-availability-store';

// Single per-app store of currently-unavailable menu items for the active
// shop. App-index constructs and owns the store; pages consume it through
// the @consume decorator and re-render on the store's onChange signal.
export const ProductAvailabilityContext = createContext<
  ProductAvailabilityStore | undefined
>('product-availability-store');
